import { initializeApp, FirebaseApp } from "firebase/app";
import 'firebase/storage';

const firebaseConfig = {
    apiKey: "AIzaSyB0qd6q-rwt38N0Zo4FziB9lH9ateW7-Ws",
    authDomain: "podsqueeze-da0f0.firebaseapp.com",
    projectId: "podsqueeze-da0f0",
    storageBucket: "podsqueeze-da0f0-w61zj",
    messagingSenderId: "698836024515",
    appId: "1:698836024515:web:1607881d73783f3b2cb676"
};

let instance: FirebaseApp | null = null;

export default function getFirebase() {
  if (typeof window !== 'undefined') {
    if (instance) return instance;
    instance = initializeApp(firebaseConfig);
    return instance;
  }
  return null;
}

// Initialize Firebase immediately if in browser environment

  instance = initializeApp(firebaseConfig);
